import { ITreeviewNhomLopFocusedValue } from "../../../components-data/treeview-nhom-lop/TreeviewNhomLop";
import { INhomLopSinhVienInsertRequest } from "../../../model/request/category/INhomLopSinhVienInsertRequest";
import { IIdsRequest } from "../../../model/request/IIdsRequest";
import { INhomLopSinhVien } from "../../../model/respone/category/INhomLopSinhVien";
import { INhomLopSinhVienViewModel } from "../../../model/respone/category/INhomLopSinhVienViewModel";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eNhomLopSinhVienActionsObj = {
    CHANGE_FOCUSED_DATA: {} as ITreeviewNhomLopFocusedValue,
    LOAD_START: {} as IIdsRequest,
    LOAD_SUCCESS: {} as INhomLopSinhVienViewModel[],
    LOAD_ERRR: "",
    CHANGE_SELECTED_IDS: {} as number[],

    SHOW_ADD_MODAL: {} as boolean,
    CLOSE_ADD_MODAL: undefined,

    ADD_START: {} as INhomLopSinhVien,
    ADD_SUCCESS: {} as INhomLopSinhVien,
    ADD_ERROR: "",

    DELETES_START: {} as IIdsRequest,
    DELETES_SUCCESS: undefined,
    DELETES_ERROR: "",

    ADDS_START: {} as INhomLopSinhVienInsertRequest,
    ADDS_SUCCESS: undefined,
    ADDS_ERROR: "",

    SCAN_ADD_PREVIEW_START: {} as IIdsRequest,
    SCAN_ADD_PREVIEW_SUCCESS: {} as INhomLopSinhVienViewModel[],
    SCAN_ADD_PREVIEW_ERROR: "",

    SCAN_ADD_START: {} as IIdsRequest,
    SCAN_ADD_SUCCESS: undefined,
    SCAN_ADD_ERROR: "",

    SCAN_REMOVE_PREVIEW_START: {} as IIdsRequest,
    SCAN_REMOVE_PREVIEW_SUCCESS: {} as INhomLopSinhVienViewModel[],
    SCAN_REMOVE_PREVIEW_ERROR: "",

    SCAN_REMOVE_START: {} as IIdsRequest,
    SCAN_REMOVE_SUCCESS: undefined,
    SCAN_REMOVE_ERROR: "",

    CLOSE_SCAN_PREVIEW_MODAL: undefined,
};
export const eNhomLopSinhVienActionIds = generateActionTypeIds(
    eNhomLopSinhVienActionsObj,
    "NHOM_LOP_SINH_VIEN"
);
export type INhomLopSinhVienActionTypes = IGenericActionType<
    typeof eNhomLopSinhVienActionsObj,
    "NHOM_LOP_SINH_VIEN"
>;
